import { ReactElement } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { Stack } from '@mui/material'
import { CheckboxLabeled } from '@ui/actions'
import { InfoTooltip } from '@ui/feedback'
import {
  CheckSettingsFormFieldsCommonProps,
  compactCheckSettingsFormSx,
  getCheckSettingsMaxWidth,
  getCheckSettingsStackSpacing,
} from './checkSettingsFormFieldLayout'

const MEMBER_SETTINGS_ROOT = 'memberCheckSettingsSelectedElement' as const

interface Props extends CheckSettingsFormFieldsCommonProps {
  memberCheckSettingsSelectedPath?: string
}

/**
 * Whether this member gets the static equilibrium check (Lagesicherheit). The
 * project setting seeds new members and sets every member when it changes;
 * in between, each member can differ from it.
 */
const StaticEquilibriumCheckSettingsFormFields = ({
  disabled,
  compact,
  memberCheckSettingsSelectedPath = MEMBER_SETTINGS_ROOT,
}: Props): ReactElement => {
  const { control } = useFormContext()
  const {
    field: { onChange, value },
  } = useController({
    name: `${memberCheckSettingsSelectedPath}.make_static_equilibrium_checks`,
    control,
  })

  return (
    <Stack
      direction="column"
      spacing={getCheckSettingsStackSpacing(compact)}
      maxWidth={getCheckSettingsMaxWidth(compact)}
      sx={compact ? compactCheckSettingsFormSx : undefined}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <CheckboxLabeled
          checked={value}
          onChange={onChange}
          label="Nachweis der Lagesicherheit führen"
          disabled={disabled}
          data-cy="static-equilibrium-check-checkbox"
        />
        <InfoTooltip
          text="Nachweis der Lagesicherheit gegen Abheben (EQU, DIN EN 1990) an den Auflagern dieses Bauteils."
          secondLineText="Beim Umschalten der Projekteinstellung „Nachweis der Lagesicherheit“ wird die Option für alle Bauteile gesetzt; danach kann sie je Bauteil abweichen."
        />
      </Stack>
    </Stack>
  )
}

export default StaticEquilibriumCheckSettingsFormFields
